import { Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { ScrumboardService } from 'app/main/pages/scrumboard/scrumboard.service';
import { Card } from 'app/main/pages/scrumboard/card.model';
import { ScrumboardCardDialogComponent } from 'app/main/pages/scrumboard/board/dialogs/card/card.component';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';

@Component({
    selector: 'scrumboard-board-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ScrumboardBoardListComponent implements OnInit, OnDestroy {

    board: any;
    dialogRef: any;
    objectId: any;
    @Input()
    list;
    @ViewChild(FusePerfectScrollbarDirective, { static: false })
    listScroll: FusePerfectScrollbarDirective;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    private _unsubscribeAll: Subject<any>;
    empRole: any;
    currentUser: any;

    /**
     * Constructor
     *
     * @param {ActivatedRoute} _activatedRoute
     * @param {ScrumboardService} _scrumboardService
     * @param {MatDialog} _matDialog
     */
    constructor(
        private _scrumboardService: ScrumboardService,
        private _matDialog: MatDialog,
        private parseService: ParseService,
        private storageConfiguration: StorageConfiguration,
        private hardCodedValues: HardCodedValues,

    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.currentUser = this.parseService.instance.User.current();
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this._scrumboardService.onBoardChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(board => {
                this.board = board;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On list name changed
     *
     * @param newListName
     */
    onListNameChanged(newListName): void {
        this.list.name = newListName;
        this._scrumboardService.updateList(this.list);
    }

    /**
     * On card added
     *
     * @param newCardName
     */
    onCardAdd(newCardName): void {

        if (newCardName === '') {
            return;
        }
        const createrProfile = this.currentUser.get('profile');
        const createrImg = createrProfile.get('profileImageInfo').url;
        const createrName = createrProfile.get('username');
        let activities = [];
        const activity = {
            message: 'Created a Task',
            createdBy: createrName,
            createdId: createrProfile.id,
            createdDate: new Date().toUTCString(),
            createrImgUrl: createrImg === undefined ? this.hardCodedValues.defaultProfileImg : createrImg
        };
        activities.push(activity);
        this._scrumboardService.saveTask(this.list.id, new Card({ name: newCardName, activities: activities }), this.board).then(res => {
            this.ngOnInit();
        });

        setTimeout(() => {
            this.listScroll.scrollToBottom(0, 400);
        });
    }

    /**
     * Remove list
     *
     * @param listId
     */
    removeList(listId): void {
        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete the list and it\'s all cards?';
        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                this._scrumboardService.removeList(listId);
            }
        });
    }

    /**
     * Open card dialog
     *
     * @param cardId
     */
    openCardDialog(cardId): void {
        this.dialogRef = this._matDialog.open(ScrumboardCardDialogComponent, {
            panelClass: 'scrumboard-card-dialog',
            width: '1200px',
            // height:'800px',
            data: {
                cardId: cardId,
                listId: this.list.id
            }
        });
        this.dialogRef.afterClosed()
            .subscribe(response => {

            });
        // this._scrumboardService.getBoard(this.board.id);
    }

    /**
     * On drop
     *
     * @param event
     */
    onDrop(event): void {
        this._scrumboardService.dropCard(event.value);
        // this._scrumboardService.updateBoard();
    }
    onOut(event): void {
        this._scrumboardService.cardOut(event.value);

    }
}
